/**
 * Chamados — wrapper simples para ChamadosInner.
 *
 * Spec: docs/CHAMADOS_VISIBILIDADE_SPEC.md §9.4.1
 *
 * O ScreenErrorBoundary sera aplicado GLOBALMENTE no AppLayout via TASK-2473;
 * por isso este wrapper NAO importa nem usa ScreenErrorBoundary aqui.
 */
import { ChamadosInner } from './ChamadosInner'

export function Chamados() {
  return <ChamadosInner />
}
